var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('el-card',{attrs:{"shadow":"never"}},[_c('div',{staticStyle:{"padding":"24px","font-size":"14px","color":"#606266"}},[_vm._v("系统权限管理 - 角色管理（待开发）")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }